import { render } from "./Cabins.vue?vue&type=template&id=2d70113c"
import script from "./Cabins.vue?vue&type=script&lang=js"
export * from "./Cabins.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__